import { PAGE_TYPE_CATEGORY, PAGE_TYPE_SEARCH_RESULTS } from 'shared/consts'
import { EXPERIMENT_NAME_MP_DELIVERY_INFO } from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import store from 'shared/store'

export default () => {
  const { isEnabled } = getExperimentOnClient(EXPERIMENT_NAME_MP_DELIVERY_INFO)
  const pageType = store.getState()?.publicRuntimeConfig.pageProperties.pageType
  if (
    !isEnabled ||
    ![PAGE_TYPE_SEARCH_RESULTS, PAGE_TYPE_CATEGORY].includes(pageType)
  )
    return

  void activateExperiment(EXPERIMENT_NAME_MP_DELIVERY_INFO)
}
